import './data'
import './numero'
import './texto'